import { ff } from '@atlassian/jira-feature-flagging';

// <wviveiro>
export const isSortingPinnedFieldsEnabled = () => ff('issue.details.sorting-pinned-fields', false);
// </wviveiro>

// <ksayapina>
export const isParentInIssueViewEnabled = () => ff('parent-field-in-issue-view_x4zn4', false);
// </ksayapina>
